import makeVarPersisted from '../utils/makeVarPersisted';

export const selectedOrganizationIdVar = makeVarPersisted<string | undefined>(undefined, 'selectedOrganizationId');
export const selectedAdAccountIdVar = makeVarPersisted<string | undefined>(undefined, 'selectedAdAccountId');
export const onboardingActiveVar = makeVarPersisted<boolean>(false, 'onboardingActive');
export const userAmsUserIdVar = makeVarPersisted<string | undefined>('', 'userAmsUserId');
export const viewedDatesVar = makeVarPersisted<string | undefined>('', 'viewedDates');
export const isBaymaxEnabledVar = makeVarPersisted<boolean | undefined>(false, 'isBaymaxEnabled');
export const showPopupNotificationOnceAfterLogin = makeVarPersisted<boolean>(
  false,
  'showPopupNotificationOnceAfterLogin'
);
